import './PanelesSolares.css';
import React from "react";
import { Link } from "react-router-dom";
import PanelesSolares1 from '../../assets/Productos/PanelesSolares/PanelesSolares1.png';
import PanelesSolares2 from '../../assets/Productos/PanelesSolares/PanelesSolares2.png';
import PanelesSolares3 from '../../assets/Productos/PanelesSolares/PanelesSolares3.png';


const images = [
    { src: PanelesSolares1, text: "MF962 Sellador electrónico de silicona", id: 38 },
    { src: PanelesSolares2, text: "MF962 L Sellador solar de silicona", id: 39 },
    { src: PanelesSolares3, text: "MF961 Sellador de silicona", id: 40 },
];

function PanelesSolares() {
    return (
        <div className="arquitectura-container">
            <div className="arquitectura-grid">
                {images.map((item, index) => (
                    <div key={index} className="arquitectura-item">
                        <Link to={`/productos/${item.id}`}>
                            <img src={item.src} alt={item.text} />
                        </Link>
                        <p>{item.text}</p> {/* Nombre del producto sin enlace */}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default PanelesSolares;
